import { makeActionCreator } from '../../../utilities'
import { GlobalDataConstants } from './globalData.constants'

export const isGlobalDataLoading = makeActionCreator(GlobalDataConstants.IS_GLOBAL_DATA_LOADING, 'isGlobalDataLoading')
export const onGlobalDataImportSuccess = makeActionCreator(GlobalDataConstants.ON_GLOBAL_DATA_IMPORT_SUCCESS)
